import { Backdrop, CircularProgress, IconButton, makeStyles } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { msmSwalError, msmSwalExito, palette } from 'configurations/styles/theme';
import { clientPay } from 'configurations/axios';
import { getRUCEmpresa, getSub } from 'redux/actions/userActions';
import Swal from 'sweetalert2';
import { API_POST_REVIEW_PAYMENT } from '../apis';

const useStyles = makeStyles(theme => ({
    IconButton: {
        marginTop: "0%",
        marginBottom: "0%",
        padding: "0px",
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}))

const AcceptPaymentBtn = ({ data, reload }) => {
    const classes = useStyles();
    const [openLoader, setOpenLoader] = useState(false);
    const tokenUser = useSelector((state) => state.user.tk);

    const isMounted = useRef(true);
    useEffect(() => {
        return () => { isMounted.current = false; }
    }, []);

    //cuando el usuario haga submit (click)
    const submitAcceptPayment = () => {
        Swal.fire({
            title: 'Aprobar paquete',
            html: "¿Está seguro de aprobar el paquete contratado?<br><br>" +
                "<input type='checkbox' id='enviarFactura' checked> " +
                "<label for='enviarFactura'>Enviar factura</label>",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const checkbox = document.getElementById('enviarFactura');
                return { enviarFactura: checkbox ? checkbox.checked : false };
            }
        }).then((result) => {
            if (result.value) {
                acceptPayment(result.value.enviarFactura);
            }
        })
    }

    const acceptPayment = async (enviarFactura) => {
        if (!isMounted.current) return;
        setOpenLoader(true);
        try {
            const response = await clientPay.post(API_POST_REVIEW_PAYMENT, {
                idAsignacionPaqueteEmpresa: data.idAsignacionPaqueteEmpresa,
                observacion: '',
                revision: true,
                rucEmpresaReceptora: data.empresaContratante.idempresacontratante,
                envioFactura: enviarFactura,
                rucEmpresa: tokenUser ? getRUCEmpresa(tokenUser) : '',
                idAsignacionEmpresaUsuario: Number(tokenUser ? getSub(tokenUser) : ''),
            });
            if (response.status === 200 && isMounted.current) {
                setOpenLoader(false);
                msmSwalExito('Proceso Exitoso', 'El paquete se ha aprobado con éxito!');
                reload();
            }
        } catch (exception) {
            if (!isMounted.current) return;
            if (exception.response) {
                msmSwalError(exception.response.data?.apierror?.mensaje || 'Error, el paquete no fue aprobado');
            } else {
                msmSwalError('Error en la red');
            }
            setOpenLoader(false);
        }
    }

    return (
        <div>

            <IconButton color="primary" aria-label="upload picture" component="span" onClick={submitAcceptPayment}
                className={classes.IconButton}
            >
                <CheckCircleOutlineIcon style={{ color: palette.primary.main }} className={classes.small} />
            </IconButton>
            <Backdrop className={classes.backdrop} open={openLoader}>
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    );
}

export default AcceptPaymentBtn;
